export var NavController = (function () {
    function NavController() {
    }
    return NavController;
}());
